export class GoCardOnFileConstants {
    /**
     * For the "New Card (EWA to contact me)" option in the cards on file dropdown
     */
    static readonly GoNewCardOnFileValue = -1;
}
